import { ErrorListOutput } from '../../types';
import moment from 'moment';

interface CommunityInput {
  communityName: string;
  coverageStart: string | null;
  buildingId?: string;
  building: {
    yearBuilt: number;
    zipCode: string;
    addressState: string;
    addressCity: string;
    addressStreet: string;
  };
}

export interface CreateCommunitySuccessResponse {
  createCommunity: {
    communityId: string;
  };
}

export interface CreateCommunityErrorResponse {
  createCommunity: ErrorListOutput & {
    communityId: never;
  };
}

export type CreateCommunityResponse =
  | CreateCommunitySuccessResponse
  | CreateCommunityErrorResponse;

export const CREATE_COMMUNITY = (
  community: CommunityInput,
  applicationId: string,
) => {
  const date = community.coverageStart
    ? moment(community.coverageStart).format('YYYY-MM-DD')
    : '';
  return `mutation {
        createCommunity(
          applicationId: "${applicationId}",
          input : {
            communityName: "${community.communityName}",
            propertyManagerName: "The Guarantors",
            coverageStart: "${date}",
            communityIsGated: false,
            numberOfUnits: 100,
            buildingId: "${community.buildingId || ''}",
            building: {
              yearBuilt: ${community.building.yearBuilt},
              zipCode: "${community.building.zipCode}",
              addressState: "${community.building.addressState}",
              addressCity: "${community.building.addressCity}",
              addressStreet: "${community.building.addressStreet}",
            }
          }){
            ... on CreateCommunityOuput {
              communityId
            }
            ... on ErrorListOutput {
              errors: errors {
                  type
                  message
              }
              }
          }
      }`;
};
